export default "__VITE_ASSET__sicpdNLk__ 480w, __VITE_ASSET__Fu3ZcOy5__ 800w, __VITE_ASSET__B0Txu1Wg__ 1200w, __VITE_ASSET__DqihLKiZ__ 1456w";